import { FC, useEffect, useState } from 'react'
import { Guid } from '../../../api/baseApi';
import { createTVChannel, deleteTVChannel, getTVChannels, TVChannel, TVChannelRequest, TVProfile, updateTVChannel } from '../../../api/tvChannelApi';
import { Button } from '../Button';
import { FormInput, FormRow } from '../formRow/FormRow';
import GlobalSpinner from '../globalsSpinner/GlobalSpinner'
import IconButton from '../iconButton/IconButton';
import { RightModal, SmallModal } from '../sideModal/Modal';

type TvChannelModalAction = "create" | "edit" | "nothing";

const TvChannels:FC = () => {
    let [isLoading, setIsLoading] = useState(false);

    let [tvChannelsList, setTvChannelsList] = useState<TVChannel[]>([]);
    let [tvChannelModalAction, setTvChannelModalAction] = useState<TvChannelModalAction>("nothing");
    let [tvChannelName, setTvChannelName] = useState("");
    let [isTvChannelNameError, setIsTvChannelNameError] = useState(false);

    let [tvChannelDomain, setTvChannelDomain] = useState('')

    let [isShowDeleteTvChannelModal, setIsShowDeleteTvChannelModal] = useState(false);
    let [tvChannelIdForAction, setTvChannelIdForAction] = useState<Guid>('');

    useEffect(()=>{

        async function fetchData() {
            setIsLoading(true);
            await Promise.all([updateTVChannelList()])
            setIsLoading(false);
        }

        fetchData()
    },[]);

    const updateTVChannelList = async () => {
        let response = await getTVChannels();
        if( response.type === "succes") {
            setTvChannelsList(response.data.items);
        }
    }

    const showTvChannelModal = (action: TvChannelModalAction, tvChannel?: TVChannel) => {
        setTvChannelModalAction(action);
        if(tvChannel){
            setTvChannelIdForAction(tvChannel.id);
            setTvChannelName(tvChannel.name);
            setTvChannelDomain(tvChannel.domain)
        }
    }

    const hideTvChannelModal = () => {
        setTvChannelModalAction("nothing");
        setTvChannelName('');
        setIsTvChannelNameError(false);
        setTvChannelDomain('')
    }

    const createOrUpdateTvChannel = async () => {
        let isValid = true;
        if(!!!tvChannelName){
            setIsTvChannelNameError(true);
            isValid = false;
        }
        
        if(!isValid) return;

        let request:TVChannelRequest = {
            name: tvChannelName,
            domain: tvChannelDomain
        }

        setIsLoading(true)
        if( tvChannelModalAction === "edit" ) {
            await updateTVChannel(tvChannelIdForAction,request)
        }

        if( tvChannelModalAction === "create" ) {
            await createTVChannel(request)
        }

        setTvChannelName('');
        hideTvChannelModal();
        await updateTVChannelList();
        setIsLoading(false);
    }

    const showDeleteTvChannelModal = (id:Guid) => {
        setIsShowDeleteTvChannelModal(true);
        setTvChannelIdForAction(id);
    }

    const hideDeleteTvChannelModal = () => {
        setIsShowDeleteTvChannelModal(false);
    }

    const removeTvChannel = async () => {
        setIsLoading(true);
        await deleteTVChannel(tvChannelIdForAction);
        await updateTVChannelList();
        setIsShowDeleteTvChannelModal(false);
        setIsLoading(false);
    }

    const renderNotMappedInProfile = (profiles: TVProfile[]) => {
        return profiles.map(it => {
            return <p key={it.id}>{it.name}</p>
        })
    }

    const renderTvChannelsList = (TVChannels: TVChannel[]) => {
        return TVChannels.map( it => {
           return <tr key={it.id}>
                <td>{it.name}</td>
                <td>{renderNotMappedInProfile(it.notMappedInProfiles)}</td>
                <td>{it.domain}</td>
                <td>
                    <IconButton tooltipText="Edit" type="edit" onClick={() => showTvChannelModal("edit", it)} />
                    <IconButton tooltipText="Delete" type="delete" onClick={() => showDeleteTvChannelModal(it.id)} />
                </td>
            </tr>
        })
    }

    return <>
        <div className="d-flex justify-content-between align-items-center mb-20 w-100">
            <h2>TV Channels</h2>
            <Button color="green"  label="Add TV Channel" onClick={() => showTvChannelModal("create")} />
        </div>

        {tvChannelsList.length ? <table className="table">
            <thead>
                <tr>
                    <td>TV Channel Name</td>
                    <td>Not Mapped In Profile</td>
                    <td>Domain</td>
                    <td></td>
                </tr>
            </thead>
            <tbody>
                {renderTvChannelsList(tvChannelsList)}
            </tbody>
        </table> : <p>Element list is empty</p>}

        <RightModal title={tvChannelModalAction === "edit" ? "Edit TV Channel" : "Add TV Channel"} show={tvChannelModalAction !== "nothing"} onRequestClose={hideTvChannelModal}>
            <FormRow>
                <FormInput 
                    errorMessage = "Please enter Name"
                    id = "tv_channel_name"
                    isError = {isTvChannelNameError}
                    title = "Name"
                    onChangeValue = {(v) => {setTvChannelName(v); setIsTvChannelNameError(false)}}
                    value = {tvChannelName}
                />
            </FormRow>

            <FormRow>
                <FormInput 
                    errorMessage = ""
                    id = "tv_profile_domain"
                    isError = {false}
                    title = "Domain"
                    onChangeValue = {(v) => {setTvChannelDomain(v)}}
                    value = {tvChannelDomain}
                />
            </FormRow>

            <div className="modal-btn-group">
                <Button color="green" label="Save" onClick={createOrUpdateTvChannel}/>
                <Button color="gray" label="Cancel" onClick={hideTvChannelModal}/>
            </div>
        </RightModal>  

        <SmallModal show={isShowDeleteTvChannelModal} onRequestClose={hideDeleteTvChannelModal}> 
            <p>That you want to delete TV Channel?</p>
            <div className="modal-btn-group">
                <Button color="gray" label="Cancel" onClick={hideDeleteTvChannelModal}/>
                <Button color="green" label="Yes" onClick={removeTvChannel}/>
            </div>
        </SmallModal>
        
        <GlobalSpinner isShow={isLoading} />
    </>
}

export default TvChannels
